export enum DisplayOrder {
  LAST_5 = "Last 5 notifications",
  LAST_10_DAYS = "Last 10 days",
  LAST_30_DAYS = "Last 30 days",
  LAST_6_MONTHS = "Last 6 months",
  THIS_YEAR = "Notifications in ",
  ALL = "All Notifications"
}